import { useLocation } from "react-router-dom";
import LayoutPage from "../../Components/LayoutPage";
import { ChallengeFactor } from "./Components/ChallengeFactor";
import { useChallenge } from "../../context/ChallengeContext";

export default function ChallengeFactorPage() {
  const location = useLocation();
  const { defaultPlanName, getPlanByName, isLoading, error } = useChallenge();
  const planNameFromUrl = new URLSearchParams(location.search).get("plan");
  const planFromState = location.state?.plan;
  const planNameFromState =
    location.state?.planName ??
    planFromState?.planName ??
    planNameFromUrl ??
    defaultPlanName;
  const selectedPlan =
    planFromState ?? getPlanByName(planNameFromState ?? defaultPlanName);

  if (isLoading && !selectedPlan) {
    return (
      <LayoutPage
        activeIndex={2}
        navItems={["خرید چالش جدید", "تأیید و پرداخت"]}
        childrenClassName="flex-1 min-h-0 flex flex-col gap-5 overflow-y-auto"
      >
        <div className="w-full flex justify-center">
          <p className="text-sm text-zi-text-light/70 dark:text-zi-text-dark/70">
            در حال بارگذاری...
          </p>
        </div>
      </LayoutPage>
    );
  }

  if (error && !selectedPlan) {
    return (
      <LayoutPage
        activeIndex={2}
        navItems={["خرید چالش جدید", "تأیید و پرداخت"]}
        childrenClassName="flex-1 min-h-0 flex flex-col gap-5 overflow-y-auto"
      >
        <div className="w-full flex justify-center">
          <p className="text-sm text-amber-400">
            دریافت اطلاعات چالش ناموفق بود.
          </p>
        </div>
      </LayoutPage>
    );
  }

  if (!selectedPlan) {
    return (
      <LayoutPage
        activeIndex={2}
        navItems={["خرید چالش جدید", "تأیید و پرداخت"]}
        childrenClassName="flex-1 min-h-0 flex flex-col gap-5 overflow-y-auto"
      >
        <div className="w-full flex justify-center">
          <p className="text-sm text-amber-400">چالش انتخاب شده یافت نشد.</p>
        </div>
      </LayoutPage>
    );
  }

  return (
    <LayoutPage
      activeIndex={2}
      navItems={["خرید چالش جدید", "انتخاب چالش"]}
      childrenClassName="flex-1 min-h-0 flex flex-col gap-5 overflow-y-auto"
    >
      <ChallengeFactor plan={selectedPlan} />
    </LayoutPage>
  );
}
